import React, { useState } from 'react';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import AlertNotification from '@/components/AlertNotification';
import { Outlet } from 'react-router-dom';
import Footer from '@/components/Footer';

const HomeLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div>
      <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <AlertNotification />
      <main>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="lg:ml-[252px]">
          <Outlet />
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default HomeLayout;
